export const STORAGE_KEYS = {
  MODULE: "@verzel:module",
} as const;
